import React, { createContext, useContext, useReducer, useEffect } from 'react';

const AppContext = createContext();

const initialState = {
  user: null,
  pendingRegistration: null,
};

function appReducer(state, action) {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.payload };
    case 'LOGOUT':
      return { ...state, user: null, pendingRegistration: null };
    case 'SAVE_PENDING_REGISTRATION':
      return { ...state, pendingRegistration: action.payload };
    case 'REGISTER_COMPANY':
      return { ...state, pendingRegistration: action.payload || null };
    case 'CLEAR_PENDING_REGISTRATION':
      return { ...state, pendingRegistration: null };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  // Sync with sessionStorage if needed (App.jsx already does some of this, but we'll adapt)
  useEffect(() => {
    const savedUser = sessionStorage.getItem('user');
    if (savedUser && savedUser !== 'undefined') {
      try {
        dispatch({ type: 'LOGIN', payload: JSON.parse(savedUser) });
      } catch (e) {
        console.error('Failed to parse user from sessionStorage', e);
      }
    }
  }, []);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}
